import { makeStyles } from '@material-ui/core/styles'

const welcomeTourStyles = makeStyles(theme => ({
   content: {
      padding: theme.spacing(3, 2, 2)
   }
}))

export default welcomeTourStyles
